import type { Capability } from '../features/capabilities';

export type ProductEdition = 'free' | 'pro';

export interface Entitlement {
  readonly edition: ProductEdition;
  readonly source: 'development-mock';
}

const FREE_CAPABILITIES: ReadonlySet<Capability> = new Set([
  'project.open',
  'data.add',
  'data.import.filter',
  'data.import.spatial',
  'labels.filter',
  'popups.basic',
  'selection.click',
  'selection.rectangle',
  'data.export',
]);

const PRO_CAPABILITIES: ReadonlySet<Capability> = new Set([
  ...FREE_CAPABILITIES,
  'composition.workspace',
  'composition.customPageSize',
  'data.displayFilter',
  'selection.byAttribute',
  'data.exportSelected',
  'export.static',
  'style.savedTemplates',
  'data.refresh',
  'map.pitch',
  'basemap.customize',
  'basemap.buildings3d',
  'annotations.author',
]);

const CAPABILITIES_BY_EDITION: Readonly<Record<ProductEdition, ReadonlySet<Capability>>> = {
  free: FREE_CAPABILITIES,
  pro: PRO_CAPABILITIES,
};

export function createMockEntitlement(edition: ProductEdition): Entitlement {
  return { edition, source: 'development-mock' };
}

export function isCapabilityAvailable(entitlement: Entitlement, capability: Capability): boolean {
  // B1a development availability is edition-neutral; B1b must settle commercial policy.
  if (capability === 'symbols.import') return true;
  return CAPABILITIES_BY_EDITION[entitlement.edition].has(capability);
}
